import { Dayjs } from 'dayjs';
import { ResourceAllocationPlanTable } from '../interfaces/interfaces';

// Shared by synced deals and copied resources when rebuilding the month columns.
export function normalizeResourcePlan(item: ResourceAllocationPlanTable, projectStart: Dayjs, monthCount: number) {
    const startDate = item.startDate.isAfter(item.endDate, 'day') ? item.endDate.endOf('day') : item.startDate;
    const months: Record<string, number> = {};
    for (let i = 0; i < monthCount; i++) {
        const month = projectStart.startOf('month').add(i, 'month');
        const outside = month.isBefore(startDate, 'month') || month.isAfter(item.endDate, 'month');
        const newlyIncluded = item.oldStartDate && item.oldEndDate &&
            (month.isBefore(item.oldStartDate, 'month') || month.isAfter(item.oldEndDate, 'month'));
        months[`month${i}`] = outside ? 0 : newlyIncluded ? item.allocation : item.months[`month${i}`] ?? item.allocation;
    }
    return { ...item, startDate, months };
}
